import AchievementEventsService from '@/services/achievementEvents'
import { mutations } from './mutations'
import EventAdapter from './adapters/eventAdapter'

export default {
  fetchAchievementEventsByUser({ commit }, userId) {
    AchievementEventsService.getCurrentWeekEventsByUserId(userId)
      .then(({ content }) => {
        const events = content.map((event) => new EventAdapter(event))
        commit(mutations.setAchievementEvents, events)
      })
      .catch((error) => console.error(error))
  },
  collectReward({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AchievementEventsService.collectReward(payload)
      .then(({ content }) => {
        if (content != null) {
          commit(mutations.updateAchievementEvent, content)
          resolve(content.userCollectedReward)
        }
      })
      .catch((error) => {
        console.error(error)
        reject(err)
      })
    })
  }
}
